import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Carousel = _resolveComponent("Carousel");
  return _openBlock(), _createBlock(_component_Carousel, {
    ref: "carouselRef",
    class: "quiz-viewer-carousel",
    mouseDrag: false,
    "items-to-show": 1,
    itemsToScroll: 1,
    "snap-align": "start",
    onSlideEnd: _ctx.onSlideChange
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "slides")]),
    _: 3
  }, 8, ["onSlideEnd"]);
}